<template>
    <div v-if="comingSoon"
        id="coming-soon-timer"
        class="coming-soon-timer"
    >
        <label class="coming-soon-timer__text">
            {{ comingSoonText }}
        </label>
        <div class="coming-soon-timer__container">
            <i v-if="!textOnly"
                :class="['coming-soon-timer__icon', comingSoonIconClass]"
            />
            <timeri18n id="coming-soon-timer-remaining-time"
                labelClass="coming-soon-timer__remaining-time"
                :endDate="endDate"
                :inTranslation="inTranslation"
                @timerFinished="onTimerFinished"
            />
        </div>
    </div>
</template>

<script>
import timeri18n from './timer-i18n.vue';
import {
    format, getLocaleObj, intervalToDuration,
} from '@shared/utils/dates';

export default {
    name: 'coming-soon-timer',
    components: {
        timeri18n,
    },
    props: {
        textOnly: {
            type: Boolean,
            default: false,
        },
        noPrefix: {
            type: Boolean,
            default: false,
        },
        endDate: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            comingSoon: this.isComingSoon(),
        };
    },
    computed: {
        inTranslation() {
            return this.noPrefix ? '' : this.$t('global.inTimePrefix');
        },

        comingSoonText() {
            const duration = intervalToDuration({
                end: new Date(this.endDate),
                start: new Date(),
            });

            if (duration.months > 0) {
                const month = format(new Date(this.endDate), 'LLLL', {
                    locale: getLocaleObj,
                });

                return this.$t('global.comingInMonth', {
                    month,
                });
            }

            return this.$t('global.comingSoon');
        },

        comingSoonIconClass() {
            const duration = intervalToDuration({
                end: new Date(this.endDate),
                start: new Date(),
            });

            const isCalendar = Boolean(duration.months > 0 || duration.days > 0 || duration.years > 0);

            return `icon-${isCalendar ? 'calendar' : 'stopper-watch'}`;
        },
    },
    watch: {
        endDate() {
            this.comingSoon = this.isComingSoon();
        },
    },
    methods: {
        onTimerFinished() {
            this.$emit('timerFinished');
            this.comingSoon = false;
        },

        isComingSoon() {
            return this.endDate && new Date(this.endDate).getTime() > Date.now();
        },
    },
};
</script>

<style lang="scss" scoped>
.coming-soon-timer {
    justify-content: center;
    text-align: center;
    display: flex;
    flex-direction: column;
    color: $black-color;

    &__text {
        font-size: 15px;
        text-transform: uppercase;
        font-family: "Monument";
    }

    &__remaining-time {
        font-size: 13px;
        font-weight: 400;
        margin-left: 5px;
    }

    &__container {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }

    &__icon {
        color: $white-color;
        font-size: 16px;
    }
}
</style>